<template>
	<div class="v-application--wrap" :class="{'mobileViewHeight': isMobile}">
		<v-app-bar class="vopsPage-toolbar" v-bind="$attrs" fixed app dense>
      <v-app-bar-nav-icon v-if="isBreakPoint" @click.stop="toggleNav" />
			<v-app-bar-nav-icon v-else @click.stop="toggleNav" @click="show = !show">
        <v-icon class="material-symbols-outlined">
          {{ !show ? 'left_panel_close' : 'left_panel_open' }}
        </v-icon>
      </v-app-bar-nav-icon>
      <slot name="app-top"></slot>
			<v-toolbar-title role="heading" aria-level="1">
				<slot name="label">{{ label }}</slot>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<slot name="actions"></slot>
			</v-toolbar-items>
			<template #extension v-if="$slots.extension">
				<slot name="extension"></slot>
			</template>
		</v-app-bar>
		<v-main class="vopsPage-main" role="region" :aria-label="PageRegion">
			<portal-target class="vopsPage-main-portal" name="main" multiple />
			<slot></slot>
		</v-main>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import navService from "../services/navService";
import {detect} from 'detect-browser';

@Component({
	inheritAttrs: false
})
export default class Page extends Vue {
	@Prop() label: string;
  isBreakPoint: boolean = false;
  show: boolean = false;

	get isMobile(){
		const browser = detect();
		return browser.os === 'iOS' || browser.os === 'Android OS';
	}

	toggleNav() {
		navService.toggleNav();
	}

  mounted() {
    this.isBreakPoint = window.matchMedia('(max-width: 1264px)').matches
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

  get PageRegion() {
        const label = this.label ? " " + this.label : "";
        return `${this.$vopsui.labels.page()}${label}`;
  }

  onResize() {
    this.isBreakPoint = window.matchMedia('(max-width: 1264px)').matches
  }
}
</script>

<style lang="scss">
	.v-tabs__bar {
		.vopsPage-toolbar & {
			background-color: transparent;
		}
	}
	.vopsPage-toolbar{
		margin-top: 0px;
	}

	.mobileViewHeight{
		min-height: 85vh !important;
	}

	@media print {
		.vopsPage-toolbar {
			display: none;
		}

		.vopsPage-main {
			padding: 0 !important;
			background-color: #fff;
		}
	}
</style>
